import { Box, styled, Typography } from '@mui/material';

interface FooterProps {
  footerLabel?: string;
  legalInformation?: string;
}

const StyledFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: `${theme.hhglobal.spacing.spacing[4].valuePx} 3.2rem`,
  gap: theme.hhglobal.spacing.spacing[1].valuePx,
})) as typeof Box;

const StyledFooterLabel = styled(Typography)(({ theme }) => ({
  fontSize: theme.hhglobal.typography.body.base.fontSize,
  fontWeight: theme.hhglobal.typography.fontWeights.regular,
  lineHeight: theme.hhglobal.typography.body.base.lineHeight,
  color: theme.hhglobal.neutral.superblack,
})) as typeof Typography;

const StyledLegalInformation = styled(Typography)(({ theme }) => ({
  fontSize: theme.hhglobal.typography.body.small.fontSize,
  fontWeight: theme.hhglobal.typography.fontWeights.regular,
  lineHeight: theme.hhglobal.typography.body.small.lineHeight,
  color: theme.hhglobal.purpose.textWeak,
})) as typeof Typography;

function Footer(props: FooterProps) {
  if (!props.footerLabel) {
    return null;
  }

  return (
    <StyledFooter component='footer'>
      <StyledFooterLabel>Current version: {props.footerLabel}</StyledFooterLabel>
      {props.legalInformation && <StyledLegalInformation>{props.legalInformation}</StyledLegalInformation>}
    </StyledFooter>
  );
}

export default Footer;
